.underline-hover:hover {
  border-bottom: 1px solid #1379c8;
}
